<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input v-model="params.id" placeholder="请输入帖子ID" clearable size="small" class="param-input"
        style="width: 220px"></el-input>
      <el-input v-model="params.title" placeholder="请输入标题" clearable size="small" class="param-input"
        style="width: 220px"></el-input>
      <el-input v-model="params.tag" placeholder="请输入标签名" clearable size="small" class="param-input"
        style="width: 180px"></el-input>
      <el-select placeholder="请选择更新状态" clearable size="small" v-model="params.updateStatus">
        <el-option :label="item.label" :value="item.value" v-for="item in updateStatuses" :key="item.value"></el-option>
      </el-select>
      <el-select placeholder="请选择状态" clearable size="small" v-model="params.status">
        <el-option :label="item.label" :value="item.value" v-for="item in statuses" :key="item.value"></el-option>
      </el-select>
      <el-select placeholder="请选择观看权限" clearable size="small" v-model="params.permission">
        <el-option :label="item.label" :value="item.value" v-for="item in permissions" :key="item.value"></el-option>
      </el-select>
      <el-select placeholder="请选择专区" clearable size="small" v-model="params.mId" @change="changeKind">
        <el-option :label="item.label" :value="item.value" v-for="item in overheadZones" :key="item.value"></el-option>
      </el-select>
      <el-select placeholder="请选择专区下专题" clearable size="small" v-model="params.sId" @change="getList('status')">
        <el-option :label="item.sectionName" :value="item.id" v-for="item in latitudes" :key="item.id"></el-option>
      </el-select>
      <el-select placeholder="请选择帖子类型" clearable size="small" v-model="params.type">
        <el-option :label="item.label" :value="item.value" v-for="item in types" :key="item.value"></el-option>
      </el-select>
      <el-select placeholder="请选择种类" clearable size="small" v-model="params.kind" @change="getList('status')">
        <el-option :label="item.label" :value="item.value" v-for="item in kinds" :key="item.value"></el-option>
      </el-select>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" size="small" @change="changeTime" style="width:360px"></el-date-picker>
      <el-button type="primary" size="small" icon="el-icon-search" @click="getList('status')"
        style="margin-right: 20px">搜索</el-button>
      <el-button type="primary" size="small" @click="batchOverhead()" :disabled="isDisabled">批量上架</el-button>
      <el-button type="primary" size="small" @click="batchTakeDown()" :disabled="isDisabled">批量下架</el-button>
      <el-button type="warning" size="small" @click="exportList" :disabled="isDisabled">导出</el-button>
      <el-button type="primary" size="small" @click="batchDelete('delete')" :disabled="isDisabled">批量删除</el-button>
      <el-button type="success" size="small" @click="batchPrice()" :disabled="isDisabled">批量更新权限/价格</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border ref="multipleTable" v-loading="loading"
      element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" height="600"
      @selection-change="handleSelectionChange" :key="updataSta">
      <el-table-column type="selection" v-if="isSelection" width="55" fixed="left" align="center">
      </el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="kind" label="种类" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.kind | getTagStyle">{{ scope.row.kind |
            getTypeLabel(allKinds) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="direction" label="排版方向" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.direction || 0 }}</span>
        </template>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.direction == 0">横版</el-tag>
          <el-tag type="success" v-else-if="scope.row.direction == 1">竖版</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="horizontalCover" label="横版封面" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="!scope.row.horizontalCover">暂无封面图</span>
          <div v-else class="picturePreview" @click="
            handlePictureCardPreview({
              url: imgUrl + scope.row.horizontalCover,
            })
            ">
            <decrypt-img style="width: 80px; height: 80px" :src="imgUrl + scope.row.horizontalCover" :iPreviewSrcList="[]" fit="fill"></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="verticalCover" label="竖版封面" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="!scope.row.verticalCover">暂无封面图</span>
          <div v-else class="picturePreview" @click="
            handlePictureCardPreview({
              url: imgUrl + scope.row.verticalCover,
            })
            ">
            <decrypt-img style="width: 80px; height: 80px" :src="imgUrl + scope.row.verticalCover" :iPreviewSrcList="[]" fit="fill"></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalEpisode" label="总集数" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.totalEpisode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="预览" align="center" width="80">
        <template slot-scope="scope">
          <i class="el-icon-video-play views" title="点击预览" @click="openSubMedia(scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column prop="updateStatus" label="更新状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.updateStatus == 1">更新中</el-tag>
          <el-tag types="danger" v-else-if="scope.row.updateStatus == 2">已完结</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">上架</el-tag>
          <el-tag v-else>下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="style" label="背景颜色" align="center" min-width="120">
        <template slot-scope="scope">
          <div class="previewColorBox" v-if="scope.row.style != 0" :class="`color${scope.row.style}`"></div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="moduleName" label="模块名称" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.moduleName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sectionName" label="专题名称" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.sectionName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sectionSort" label="专题排序" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sectionSort || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tagDetails" label="标签" align="center" width="240">
        <template slot-scope="scope">
          <div v-for="(tag, i) in scope.row.tagDetails" :key="i" class="tagBox">
            <el-tag type="success" size="mini" effect="plain" class="tagDetails">{{ "#" + tag.name }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="mediaType" label="类型" align="center" width="120">
        <template slot-scope="scope">
          <el-tag style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-if="scope.row.mediaType == 'video'">动漫</el-tag>
          <el-tag type="success" v-else-if="scope.row.mediaType == 'image'">漫画</el-tag>
          <el-tag type="warning" v-else-if="
            scope.row.mediaType == 'text' && scope.row.mediaSubType == 0
          ">文本小说</el-tag>
          <el-tag v-else-if="
            scope.row.mediaType == 'text' && scope.row.mediaSubType == 1
          ">有声小说</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="freeTime" label="免费时长" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.freeTime || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.price || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sellType" label="售卖类型" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sellType || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countBrowse" label="浏览数" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.countBrowse || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countCollect" label="收藏数" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.countCollect || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countComment" label="评论数" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.countComment || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countLike" label="喜欢数" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.countLike || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countPurchases" label="购买数" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.countPurchases || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countView" label="展现数" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.countView || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="permission" label="观看权限" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.permission == 0">会员</el-tag>
          <el-tag type="warning" v-else-if="scope.row.permission == 1">金币</el-tag>
          <el-tag v-else>免费</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="permissionIconHide" label="售卖类型标识隐藏" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.permissionIconHide">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="summary" label="简介" align="center" width="360">
        <template slot-scope="scope">
          <span>{{ scope.row.summary || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAct" label="操作人" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="280" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="success" icon="el-icon-edit" @click="addAndEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
          <template v-if="params.sId">
            <br /><br />
            <el-button size="mini" type="danger" @click="removeSection(scope.row)">移除当前专题</el-button>
            <el-button size="mini" type="warning" @click="setSectionSort(scope.row)">设置专题排序</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="bottom">
      <div class="btn" v-if="isSelection">
        <el-button type="info" size="mini" @click="giveUp">放弃操作</el-button>
        <el-button type="primary" size="mini" @click="subSection">提交</el-button>
      </div>
      <div class="page">
        <el-pagination :page-sizes="[10, 25, 50, 100]" :current-page="params.pageNumber" :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10"
          @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
      </div>
    </div>
    <!-- 新增、修改 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="950px" @before-close="handleClose"
      @close="handleClose">
      <el-form :model="form" label-width="80px" :rules="rules" ref="form">
        <div class="itemBox">
          <el-form-item label="标题:" size="small" prop="title" style="width: 900px">
            <el-input type="textarea" row="2" v-model="form.title"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item label="简介:" size="small" prop="summary" style="width: 900px">
            <el-input type="textarea" row="5" v-model="form.summary"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item label="价格:" size="small" prop="price" style="width: 480px">
            <el-input v-model.number="form.price"></el-input>
          </el-form-item>
          <el-form-item label="免费时长:" size="small" prop="freeTime" style="width: 480px">
            <el-input v-model.number="form.freeTime"></el-input>
          </el-form-item>
          <el-form-item label="总集数:" size="small" prop="totalEpisode" style="width: 480px">
            <el-input v-model.number="form.totalEpisode"></el-input>
          </el-form-item>
          <el-form-item label="专题排序:" size="small" prop="sectionSort" style="width: 480px">
            <el-input v-model.number="form.sectionSort"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item label="状态:" size="small" prop="status" style="width: 480px">
            <el-select placeholder="请选择状态" clearable size="small" v-model="form.status">
              <el-option :label="item.label" :value="item.value" v-for="item in statuses" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="帖子类型:" size="small" prop="mediaType" style="width: 480px">
            <el-select clearable size="small" :disabled="true" v-model="form.mediaType">
              <el-option :label="item.label" :value="item.value" v-for="item in types" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="子类型:" size="small" prop="mediaSubTypes" style="width: 480px"
            v-if="form.mediaType == 'text'">
            <el-select size="small" v-model="form.mediaSubType">
              <el-option :label="item.label" :value="item.value" v-for="item in mediaSubTypes"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="观看权限:" size="small" prop="permission" style="width: 480px">
            <el-select clearable size="small" v-model="form.permission">
              <el-option :label="item.label" :value="item.value" v-for="item in permissions"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item label="更新状态:" size="small" prop="updateStatus" style="width: 480px">
            <el-select placeholder="请选择更新状态" clearable size="small" v-model="form.updateStatus">
              <el-option :label="item.label" :value="item.value" v-for="item in updateStatuses"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="帖子种类:" size="small" prop="kind" style="width: 480px">
            <el-select placeholder="请选择种类" clearable size="small" v-model="form.kind">
              <el-option :label="item.label" :value="item.value" v-for="item in dialogKinds" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排版方向:" size="small" prop="direction" style="width: 480px">
            <el-select clearable size="small" v-model="form.direction">
              <el-option :label="item.label" :value="item.value" v-for="item in directions"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item label="标签类型:" size="small" prop="type" style="width: 250px">
            <el-select @change="getTagDimensionsList()" clearable size="small" v-model="form.type"
              placeholder="请选择标签类型">
              <el-option :label="item.label" :value="item.number" v-for="item in types" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维度:" size="small" prop="dimension" style="width: 250px">
            <el-select @change="getTagList" v-model="form.dimension" placeholder="请选择维度" clearable>
              <el-option v-for="k in dimensions" :key="k.id" :label="k.name" :value="k.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="背景颜色:" prop="style" style="width: 250px">
            <el-select v-model="form.style" placeholder="请选择背景颜色" size="small" clearable>
              <el-option v-for="k in styles" :key="k.value" :label="k.label" :value="k.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="背色预览:" style="width: 250px">
            <div class="previewColorBox" :class="`color${form.style}`"></div>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item label="标签:" prop="tagObjs">
            <tag-selector v-model="form.tagObjs" :tagList="tagList" v-if="isTagSelector"></tag-selector>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item size="small" label="横版封面:" prop="horizontalCover" style="width: 480px">
            <base-upload :cover="form.horizontalCover" :action="uploadUrl" @successCallback="uploadHCover"
              :width="'213px'" :height="'120px'" :hide="true"></base-upload>
          </el-form-item>
          <el-form-item size="small" label="竖版封面:" prop="horizontalCover" style="width: 480px">
            <base-upload :cover="form.horizontalCover" :action="uploadUrl" @successCallback="uploadVCover"
              :width="'120px'" :height="'213px'" :hide="true"></base-upload>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!--视频预览弹窗-->
    <preview-media ref="previewMedia" @handlerVideoList="getList"></preview-media>
    <el-dialog :title="batchContent == 'delete'
        ? '批量删除'
        : batchContent == 'remove'
          ? '批量移除'
          : batchContent == 'overhead'
            ? '批量上架'
            : '批量下架'
      " :visible.sync="isBatchDelete" width="1300px" @close="closeBatch">
      <div class="optBox" v-if="batchContent == 'overhead'">
        <el-select class="zone" v-model="overheadZone" placeholder="请选择专区" size="small" clearable
          @change="searchMediaTopic" style="width: 220px">
          <el-option v-for="s in overheadZones" :key="s.value" :label="s.label" :value="s.value">
          </el-option>
        </el-select>
        <el-select v-model="overheadMediaTopicId" placeholder="请选择专区下专题" style="width: 220px" size="small" clearable>
          <el-option v-for="m in overheadMediaTopics" :key="m.id" :label="m.sectionName" :value="m.id">
          </el-option>
        </el-select>
      </div>
      <el-table :data="videoIds" highlight-current-row border class="batchdelete">
        <el-table-column prop="id" label="帖子ID" align="center" min-width="220" fixed="left"></el-table-column>
        <el-table-column prop="mediaType" label="帖子类型" align="center" min-width="140" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ handlerMediaType(scope.row.kind) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">上架</el-tag>
            <el-tag type="danger" v-else>下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="视频标题" align="center" :show-overflow-tooltip="true" min-width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.title || "未知" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="横版封面" align="center" min-width="140">
          <template slot-scope="scope">
            <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.horizontalCover"></img-load>
          </template>
        </el-table-column>
        <el-table-column label="竖版封面" align="center" min-width="140">
          <template slot-scope="scope">
            <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.verticalCover"></img-load>
          </template>
        </el-table-column>
      </el-table>
      <div class="dialog-footer">
        <el-button @click="cancelBatechDel">取 消</el-button>
        <el-button type="primary" @click="confirmSubmit" :loading="isBatchDeleteLoading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量设置权限/价格 -->
    <DialogSetPrice :visible.sync="visibleSetPrice" @submit="callSetPrice"></DialogSetPrice>
  </div>
</template>
<script>
import API from "@/api";
import { changeTime } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import PreviewMedia from "./components/preview-media";
import DialogSetPrice from "./components/dialog-set-price";
import TagSelector from "@/components/mediaTagSelector";
import { videoPermissionTypes } from "../../../config";
import { animeKinds, animeLabelTypes, animeTypes, animeUpdateStatus } from "../../../config/anime";

export default {
  components: {
    PreviewMedia,
    TagSelector,
    DialogSetPrice
  },
  data() {
    return {
      visibleSetPrice: false,
      // 表格数据加载动画
      loading: false,
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      imgUrl: baseConfig.imgUrl,
      // 列表数据
      tableData: [],
      dimensions: [],
      tagList: [], //标签列表：包含标签名称和标签id
      total: 0,
      time: "",
      params: {
        pageNumber: 1,
        pageSize: 10,
        id: undefined, // id
        title: undefined, // 标题
        tag: undefined, // 标签名
        status: undefined, // 状态
        updateStatus: undefined, // 更新状态
        type: undefined, // 帖子类型
        kind: undefined, // 种类
        permission: undefined, // 观看权限
        mId: undefined, // 专区
        sId: undefined, // 专题ID
        start: "", //开始日期
        end: "", //结束日期
      },
      latitudes: [], //
      rules: {
        name: [{ required: true, message: "请输入播单名称", trigger: "blur" }],
        cover: [{ required: true, message: "请上传图片", trigger: "blur" }],
        uid: [{ required: true, message: "请输入用户ID", trigger: "blur" }],
      },
      types: animeTypes,
      statuses: [
        {
          label: "上架",
          value: 1,
        },
        {
          label: "下架",
          value: 2,
        },
      ],
      updateStatuses: animeUpdateStatus,
      actives: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      typeses: animeLabelTypes,
      permissions: videoPermissionTypes,
      directions: [
        {
          label: "横",
          value: 0,
        },
        {
          label: "竖",
          value: 1,
        },
      ],
      mediaSubTypes: [
        {
          label: "文本小说",
          value: 0,
        },
        {
          label: "有声小说",
          value: 1,
        },
      ],
      styles: [
        { label: "酱色", value: 1 },
        { label: "黛紫", value: 2 },
        { label: "紺青", value: 3 },
        { label: "砺茶", value: 4 },
        { label: "黛绿", value: 5 },
        { label: "胭脂", value: 6 },
        { label: "桔梗", value: 7 },
        { label: "海涛", value: 8 },
        { label: "土豪", value: 9 },
        { label: "绿铜", value: 10 },
      ],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        title: undefined, // 标题
        summary: undefined, // 简介
        price: 0, // 价格
        freeTime: 0, // 免费试看时长 单位 s
        totalEpisode: 1, // 总集数
        status: 1, // 状态
        updateStatus: 1, // 更新状态
        mediaType: undefined, // 媒体类型
        permission: 0, // 收听权限 0:会员 1:金币购买 2:免费
        kind: 1, // 种类 1动漫 2漫画
        direction: 0, // 排版方向 0横 1竖
        tags: [], // 标签
        tagObjs: [],
        horizontalCover: undefined, // 横版封面
        verticalCover: undefined, // 竖版封面
        style: undefined, // 背景颜色
        mediaSubType: 0, // 子类型，小说时才使用
        sectionSort: 0, // 专题排序
      },
      isSelection: false,
      isDisabled: false,
      updataSta: false,
      batchContent: "", // 批量操作的内容
      videoIds: [],
      isBatchDelete: false,
      isBatchDeleteLoading: false,
      overheadZone: undefined,
      overheadMediaTopicId: undefined,
      overheadMediaTopics: [],
      overheadZones: [],
      moduleCartoonAll: [],
      isTagSelector: true,
    };
  },
  computed: {
    kinds() {
      this.params.kind = null
      const type = this.types.find(v => v.value === this.params.type)
      if (type) {
        return type.kinds
      }
      return animeKinds
    },
    dialogKinds() {
      const type = this.types.find(v => v.value === this.form.mediaType)
      if (type) {
        return type.kinds
      }
      return animeKinds
    },
    allKinds() {
      return animeKinds
    }
  },
  created() {
    this.getList();
    // this.getAllLatitude();
    this.getModuleCartoonAll();
  },
  methods: {
    // 横版封面上传成功
    uploadHCover(res) {
      this.form.horizontalCover = res.data.coverImg;
    },
    // 竖版封面上传成功
    uploadVCover(res) {
      this.form.verticalCover = res.data.coverImg;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    // 请求种类下的维度列表数据
    getTagDimensionsList() {
      this.tagList = [];
      API.getAnimeAllLatitude({
        type: this.form.type,
      })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dimensions = res.data.list || [];
          } else {
            this.dimensions = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.dimensions = [];
          this.loading = false;
        });
    },
    getTagList() {
      this.tagList = [];
      if (this.form.type === undefined) {
        this.$message.error("请选择类型");
        return;
      }
      if (this.form.dimension === undefined || this.form.dimension === "") {
        this.$message.error("请选择维度");
        return;
      }
      const param = {
        type: this.form.type,
        kind: this.form.kind,
        dimension: this.form.dimension,
      };
      API.getMediaTagByKindDimension(param).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data || [];
        }
      });
    },
    getAllLatitude() {
      API.getAnimeAllLatitude()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.latitudes = res.data.list || [];
          } else {
            this.latitudes = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getAnimeList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增播单
    addAndEdit(param) {
      this.isTagSelector = true;
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.title = param.title;
        this.form.summary = param.summary;
        this.form.price = param.price;
        this.form.freeTime = param.freeTime;
        this.form.totalEpisode = param.totalEpisode;
        this.form.status = param.status;
        this.form.updateStatus = param.updateStatus;
        this.form.mediaType = param.mediaType;
        this.form.permission = param.permission;
        this.form.kind = param.kind;
        this.form.direction = param.direction;
        this.form.horizontalCover = param.horizontalCover;
        this.form.verticalCover = param.verticalCover;
        this.form.mediaSubType = param.mediaSubType;
        this.form.sectionSort = param.sectionSort;
        this.form.tagObjs = param.tagDetails || [];
        this.getTagDimensionsList();
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addAnime(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var tags = [];
          for (const t of this.form.tagObjs) {
            tags.push(t.id);
          }
          this.form.tags = tags;
          API.updateAnime(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>播单, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delAnime(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.title = undefined;
      this.form.summary = undefined;
      this.form.price = 0;
      this.form.freeTime = 0;
      this.form.totalEpisode = 1;
      this.form.status = 1;
      this.form.updateStatus = 1;
      this.form.mediaType = undefined;
      this.form.permission = 0;
      this.form.kind = 1;
      this.form.direction = 0;
      this.form.tags = [];
      this.form.tagObjs = [];
      this.form.horizontalCover = undefined;
      this.form.verticalCover = undefined;
      this.form.dimension = undefined;
      this.form.type = undefined;
      this.form.mediaSubType = 0;
      this.form.sectionSort = 0;
      this.isTagSelector = false;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0]) || "";
        this.params.end = changeTime(time[1]) || "";
      } else {
        this.params.start = "";
        this.params.end = "";
      }
      this.getList("status");
    },
    // 预览
    openSubMedia(row) {
      this.$refs.previewMedia.open(row);
    },
    // 批量删除
    async batchDelete() {
      this.batchContent = "delete";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量更新权限/价格
    async batchPrice() {
      this.batchContent = "price";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量下架
    batchTakeDown() {
      this.batchContent = "takeDown";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量上架
    batchOverhead() {
      this.batchContent = "overhead";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.videoIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.videoIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      let tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.videoIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.videoIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.videoIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.videoIds = this.videoIds.concat(objArr);
      const tempVideos = new Set(this.videoIds);
      this.videoIds = Array.from(tempVideos);
    },
    // 翻页时的勾选回显
    restoreCheckedState() {
      /**
       * ①获取到当前数据表格中已经被选中的数据
       */
      const indexs = this.tableData
        .map((item) => {
          let flag = false;
          this.videoIds.forEach((value) => {
            value.id === item.id ? (flag = true) : "";
          });
          if (flag) {
            return item;
          }
        })
        .filter((item) => item);
      /**
       * ②回显当前数据表格中已经被勾选过的数据
       */
      this.$nextTick(() => {
        indexs.forEach((rows) => {
          this.$refs.multipleTable.toggleRowSelection(rows);
        });
      });
    },
    openSelection(param) {
      this.batchContent = param ? param : "featured";
      this.isSelection = true;
      this.isDisabled = true;
    },
    giveUp() {
      this.batchContent = "";
      this.isDisabled = false;
      this.isSelection = false;
      this.visibleSetPrice = false;
      this.subSections = "";
      this.subSectionId = "";
      this.videoIds = [];
      this.$refs.multipleTable.clearSelection();
    },
    cancelBatechDel() {
      this.isBatchDelete = false;
    },
    subSection() {
      if (this.videoIds.length == 0) {
        this.$message.error("请至少选择一条数据");
        return;
      }
      if (this.batchContent === "featured") {
        this.isFeatured = true;
      } else if (
        this.batchContent === "overhead" ||
        this.batchContent === "takeDown" ||
        this.batchContent === "delete" ||
        this.batchContent === "remove"
      ) {
        this.isBatchDelete = true;
      } else if (this.batchContent === 'price') {
        this.visibleSetPrice = true;
      } else {
        this.dialogVisible = true;
      }
    },
    getModuleCartoonAll() {
      API.queryModuleCartoonAll()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.moduleCartoonAll = res.data || [];
            this.overheadZones = this.moduleCartoonAll.map((item) => {
              return {
                label: item.moduleName,
                value: item.id,
              };
            });
          } else {
            this.moduleCartoonAll = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.moduleCartoonAll = [];
          this.loading = false;
        });
    },
    //获取种类下媒体话题
    searchMediaTopic() {
      if (this.overheadZone === undefined) {
        this.$message.error("请选择专区");
        return;
      }
      this.moduleCartoonAll.filter((item) => {
        if (item.id == this.overheadZone) {
          this.overheadMediaTopics = item.allSection;
        }
      });
    },
    //获取种类下媒体话题
    changeKind() {
      if (this.params.mId === undefined) {
        this.$message.error("请选择专区");
        return;
      }
      this.moduleCartoonAll.filter((item) => {
        if (item.id == this.params.mId) {
          this.latitudes = item.allSection;
        }
      });
    },
    // 确认批量删除
    async confirmBatechDel() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.batchDelMedia(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error(ret.tip || ret.msg || "删除失败！");
      }
    },
    confirmSubmit() {
      if (this.batchContent == "overhead") {
        this.confirmOverhead();
      } else if (this.batchContent == "remove") {
        this.confirmRemove();
      } else if (this.batchContent == "takeDown") {
        this.confirmTakeDown();
      } else if (this.batchContent == "delete") {
        this.confirmBatechDel();
      }
    },
    // 确认批量下架
    async confirmTakeDown() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
        isActive: false,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.setMediaStatus(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "下架成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error("下架失败！");
      }
    },
    // 确认批量上架
    async confirmOverhead() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
        sId: this.overheadMediaTopicId,
        isActive: true,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.setMediaStatus(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "上架成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getMediaList();
      } else {
        this.$message.error("上架失败！");
      }
    },
    handlerMediaType(kind) {
      const t  = animeKinds.find(v => v.value == kind)
      return t ? t.label : ''
    },
    removeSection(row) {
      let req = {
        id: row.id,
        isRemove: true,
      };
      this.$confirm(`确认是否移除, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      }).then(() => {
        API.updateAnime(req)
          .then((ret) => {
            if (ret.code === 200) {
              this.$message({
                type: "success",
                message: "移除成功",
              });
              this.getMediaList();
            } else {
              this.$message({
                type: "error",
                message: "移除失败",
              });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消",
            });
          });
      });
    },
    setSectionSort(row) {
      this.$prompt("请输入视频在专题中的排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]\d*$/,
        inputErrorMessage: "请输入正整数",
      })
        .then(async ({ value }) => {
          let req = {
            id: row.id,
            sectionSort: Number(value),
          };
          let ret = await API.updateAnime(req);
          if (ret.code === 200) {
            this.$message({
              type: "success",
              message: "设置成功",
            });
            this.getMediaList();
          } else {
            this.$message({
              type: "error",
              message: "设置失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    async callSetPrice(data) {
      try {
        let videoIDs = this.videoIds.map((item) => item.id);
        const params = {
          ids: videoIDs,
          ...data
        }
        const r = await API.batchUpdatePrice(params)
        this.$message.success('设置成功')
        this.giveUp();
        this.close();
        this.getList();
      } catch (error) {
        console.error(' call set price error：', error);
      }
    },
    exportList() {
      let req = JSON.parse(JSON.stringify(this.params));
      this.exportLoading = true;
      API.exportMediaList(req)
        .then((res) => {
          if (res) {
            try {
              var blob = new Blob([res], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
              }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
              var downloadElement = document.createElement("a");
              var href = window.URL.createObjectURL(blob); // 创建下载的链接
              downloadElement.href = href;
              downloadElement.download = "动漫列表.xlsx"; // 下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); // 点击下载
              document.body.removeChild(downloadElement); // 下载完成移除元素
              window.URL.revokeObjectURL(href); // 释放掉blob对象
            } catch (error) {
              console.log(error);
              this.$message.error("导出失败！");
            }
          }
        })
        .catch(() => {
          this.$message.error("导出失败！");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 关闭窗口
    close() {
      this.isBatchDelete = false;
    },
    closeBatch() {
      this.overheadMediaTopicId = undefined;
      this.overheadZone = undefined;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  margin-top: 20px;
}

/deep/ .el-form-item__content {
  display: flex;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}

/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}

.itemBox {
  display: flex;
}

.tagBox {
  display: inline-block;
  margin-right: 5px;
}

.bottom {
  margin-top: 20px;

  .btn {
    display: inline-block;
    margin-left: 20px;
  }

  .page {
    display: inline-block;
    float: right;
  }
}

.optBox {
  margin-bottom: 20px;
}

.zone {
  margin-right: 20px;
}

.previewColorBox {
  height: 30px;
  width: 70px;
}

.color1 {
  background: rgb(108, 21, 6);
}

.color2 {
  background: rgb(60, 46, 70);
}

.color3 {
  background: rgb(15, 51, 90);
}

.color4 {
  background: rgb(119, 78, 67);
}

.color5 {
  background: rgb(56, 97, 102);
}

.color6 {
  background: rgb(156, 45, 61);
}

.color7 {
  background: rgb(133, 60, 131);
}

.color8 {
  background: rgb(0, 85, 151);
}

.color9 {
  background: rgb(198, 143, 84);
}

.color10 {
  background: rgb(74, 150, 136);
}
</style>
